module.exports = {"title":"Einloggen","emailPH":"Email","pwdPH":"Passwort","submitTxt":"Einloggen","errMsg":"Deine Anmeldung war nicht erfolgreich","registerHint1":"Noch keinen Account ?","registerHint2":"Hier geht es zur Anmeldung"}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/login/nl.json
// module id = +HJ+
// module chunks = 1